import gql from 'graphql-tag';

export const FRAGMENT_MULTILINE = gql`
  fragment multiTextConf on MultiText {
    multiText: description
    id
    maxLength
    minLength
    regex
    messages {
      correct
      incomplete
      incorrect
    }
    __typename
  }
`;
